<template>
  <div class="contenido-centrado">
    <a-spin :spinning="spin">
      <a-card hoverable>
        <a-card-meta title="Verificación de certificado"
                     description="Para consultar el certificado, por favor ingrese todos los campos requeridos que se muestran a continuación.">
          <a-avatar
            style="backgroundColor:#108ee9"
            slot="avatar"
            icon="printer"
          />
        </a-card-meta>
        <br>
        <a-form-model layout="vertical" :key="keyForm" :model="infoLaboralForm" :rules="formRules" ref="formContrato">
          <a-row :gutter="[2,0]" :md="12" :xs="24">
            <a-col v-bind="colSpan">
              <a-form-model-item :label="$t('Tipo de certificado')" prop="cert_type" has-feedback>
                <a-select default-value="lucy" v-model="infoLaboralForm.cert_type">
                  <a-icon slot="suffixIcon" type="snippets"/>
                  <a-select-option v-for="opcion in tiposCertificado" :key="opcion.text">
                    {{ opcion.text }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col v-bind="colSpan">
              <a-form-model-item :label="$t('Identificación')" prop="identification" has-feedback>
                <a-input v-model="infoLaboralForm.identification">
                  <a-icon slot="prefix" type="user"/>
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col v-bind="colSpan">
              <a-form-model-item :label="$t('Código de verificación')" prop="verify_code" has-feedback>
                <a-input v-model="infoLaboralForm.verify_code">
                  <a-icon slot="prefix" type="pushpin"/>
                </a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
        <a-button id="infoLabButton" type="primary" icon="search" @click="search()">
          Consultar información
        </a-button>
        <br>
        <br>
        <a-empty v-if="noData" description="No se encontraron resultados"/>
        <div v-if="showInfoEmp">
          <a-descriptions :title="$t('Información del certificado laboral')" bordered size="middle">
            <a-descriptions-item :label="$t('Fecha Generación')">{{infoEmpl.date_system}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Nombre')">{{infoEmpl.nombre_empleado}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Cargo')">{{infoEmpl.job_emp}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Salario')">{{infoEmpl.salary_emp}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Tipo Contrato')">{{infoEmpl.contract_type}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Fecha Ingreso')">{{infoEmpl.initial_date}}</a-descriptions-item>
            <a-descriptions-item :label="$t('Fecha Terminación')">{{infoEmpl.end_date}}</a-descriptions-item>
            <a-descriptions-item v-if="infoEmpl && infoEmpl.extra_hours" :label="$t('Horas extras')">{{infoEmpl.extra_hours}}</a-descriptions-item>
            <a-descriptions-item v-if="infoEmpl && infoEmpl.payments_salary" :label="$t('Pagos Salariales')">{{infoEmpl.payments_salary}}</a-descriptions-item>
            <a-descriptions-item v-if="infoEmpl && infoEmpl.payments_no_salary" :label="$t('Pagos No Salariales')">{{infoEmpl.payments_no_salary}}</a-descriptions-item>
            <a-descriptions-item v-if="infoEmpl && infoEmpl.termination_reason" :label="$t('Motivo de retiro')">{{infoEmpl.termination_reason}}</a-descriptions-item>
          </a-descriptions>
        </div>
      </a-card>
    </a-spin>
  </div>
</template>

<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        keyForm: 0,
        showInfoEmp: false,
        infoEmpl: {
          job_emp: null,
          salary_emp: null,
          date_system: null,
          initial_date: null,
          contract_type: null,
          extra_hours: null,
          payments_salary: null,
          payments_no_salary: null,
          nombre_empleado: null,
          end_date: null,
          termination_reason: null,
        },
        noData: false,
        tiposCertificado: [],
        spin: false,
        colSpan: {
          xs: 24,
          md: 12
        },
        infoLaboralForm: {
          cert_type: null,
          identification: null,
          verify_code: null
        },
        formRules: {
          cert_type: [{required: true, message: 'Valor requerido'}],
          verify_code: [{required: true, message: 'Valor requerido'}],
          identification: [{required: true, message: 'Valor requerido'}]
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.httpClient.getInstance().get('hierarchy_lookup/public_dropdown?h_lookup_type=VERIFICACION_CERTIFICADO')
        .then((response) => {
          this.tiposCertificado = response.data.data
        })
        .catch((error) => {
          Mensajes.error('Error', 'Error desconocido, contacte al administrador')
        })
        .then(() => {
          if (this.tiposCertificado.length > 0) {
            if (this.$route.params.tipocertificado && this.$route.params.identificacion && this.$route.params.consecutivo) {
              this.infoLaboralForm = {
                cert_type: this.$route.params.tipocertificado,
                identification: this.$route.params.identificacion,
                verify_code: this.$route.params.consecutivo
              }
              this.keyForm++
              this.showInfoEmp = false
              this.noData = false
              this.spin = true
              this.consultLogCertLab()
            }
          }
        })
    },
    methods: {
      search () {
        this.$refs.formContrato.validate(valid => {
          if (valid) {
            this.showInfoEmp = false
            this.noData = false
            this.spin = true
            this.consultLogCertLab()
          }
        })
      },
      consultLogCertLab () {
        this.httpClient.getInstance().post('public/log_cert_lab', this.infoLaboralForm)
          .then((response) => {
            this.noData = false
            this.showInfoEmp = true
            this.infoEmpl.job_emp = response.data.job_emp
            this.infoEmpl.salary_emp = response.data.salary_emp
            this.infoEmpl.date_system = response.data.date_system
            this.infoEmpl.initial_date = response.data.initial_date
            this.infoEmpl.contract_type = response.data.contract_type
            this.infoEmpl.extra_hours = response.data.extra_hours
            this.infoEmpl.payments_salary = response.data.payments_salary
            this.infoEmpl.payments_no_salary = response.data.payments_no_salary
            this.infoEmpl.nombre_empleado = response.data.nombre_empleado
            this.infoEmpl.end_date = response.data.end_date
            this.infoEmpl.termination_reason = response.data.termination_reason
          })
          .catch((errro) => {
            console.log(errro)
            this.noData = true
            this.showInfoEmp = false
          })
          .then(() => {
            this.spin = false
          })
      }
    }
  }
</script>

<style scoped>
  .contenido-centrado {
    margin-top: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/InfoLaboral/InfoLaboral.vue